module.exports = __webpack_public_path__ + "img/grant_middle.4297e1bd.png";